import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Label.module.css';
export const Label = forwardRef(({ required = false, disabled = false, className = '', children, ...props }, ref) => {
    const classes = [styles.label, disabled && styles.disabled, className]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("label", { ref: ref, className: classes, ...props, children: [children, required && (_jsx("span", { className: styles.required, "aria-label": "required", children: "*" }))] }));
});
Label.displayName = 'Label';
